var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPawnWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 170,
    viewBox: "0 0 170 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_227_2296)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.1131 124.706C38.6936 124.706 38.2686 124.635 37.8518 124.484C35.9352 123.787 34.9427 121.668 35.6391 119.751C41.8194 102.727 60.7196 101.092 61.523 101.032C63.5493 100.881 65.3315 102.4 65.4878 104.435C65.6441 106.467 64.1251 108.238 62.096 108.397C61.4627 108.449 47.1141 109.79 42.5844 122.271C42.0415 123.774 40.6239 124.706 39.1131 124.706Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.307 110.591C105.402 110.591 101.119 107.643 100.81 107.424C99.148 106.242 98.7587 103.936 99.9405 102.272C101.117 100.618 103.401 100.226 105.06 101.381C105.518 101.688 114.64 107.501 128.317 96.4917C129.907 95.2112 132.229 95.4634 133.51 97.0538C134.79 98.6413 134.538 100.969 132.948 102.247C124.876 108.743 117.771 110.591 112.307 110.591Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.088 143.028C113.343 138.117 105.301 138.103 105.301 138.103V126.705H89.8145L96.8393 143.028H116.088Z",
    fill: "#CFDED1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.269 143.028C48.0137 138.117 56.0558 138.103 56.0558 138.103V126.705H71.5423L64.5174 143.028H45.269Z",
    fill: "#CFDED1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2815 99.0226V126.705H48.2439L57.7145 99.0226H81.2815Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2814 99.0226V126.705H114.319L104.851 99.0226H81.2814Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2816 112.864C101.171 112.864 117.294 96.7403 117.294 76.8511C117.294 56.9619 101.171 40.8385 81.2816 40.8385C61.3924 40.8385 45.269 56.9619 45.269 76.8511C45.269 96.7403 61.3924 112.864 81.2816 112.864Z",
    fill: "#CFDED1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.446 96.2723H81.2813H57.1194L53.6344 106.456C60.1767 114.468 70.1299 119.584 81.2813 119.584C92.4328 119.584 102.386 114.468 108.928 106.456L105.446 96.2723Z",
    fill: "#CFDED1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2814 109.017C97.6861 109.017 110.985 95.7183 110.985 79.3136C110.985 62.9089 97.6861 49.6102 81.2814 49.6102C64.8767 49.6102 51.578 62.9089 51.578 79.3136C51.578 95.7183 64.8767 109.017 81.2814 109.017Z",
    fill: "#C17468"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.9709 89.2174C101.57 89.2174 105.298 85.4891 105.298 80.8901C105.298 76.2911 101.57 72.5629 96.9709 72.5629C92.3719 72.5629 88.6437 76.2911 88.6437 80.8901C88.6437 85.4891 92.3719 89.2174 96.9709 89.2174Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.7413 72.6011C95.6766 74.1174 94.3303 76.555 94.3303 79.3106C94.3303 83.6483 97.6508 87.2101 101.887 87.5995C103.952 86.0832 105.298 83.6456 105.298 80.89C105.298 76.5522 101.98 72.9904 97.7413 72.6011Z",
    fill: "#2F4579"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9442 89.2174C68.5432 89.2174 72.2715 85.4891 72.2715 80.8901C72.2715 76.2911 68.5432 72.5629 63.9442 72.5629C59.3452 72.5629 55.6169 76.2911 55.6169 80.8901C55.6169 85.4891 59.3452 89.2174 63.9442 89.2174Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7146 72.6011C62.6499 74.1174 61.3036 76.555 61.3036 79.3106C61.3036 83.6483 64.6241 87.2101 68.8604 87.5995C70.925 86.0832 72.2713 83.6456 72.2713 80.89C72.2713 76.5522 68.9508 72.9904 64.7146 72.6011Z",
    fill: "#2F4579"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.168 41.1184C95.1118 36.0129 83.9548 39.1936 78.0131 37.5375C73.8947 36.3886 73.7192 32.1825 71.6984 32.6321C69.6776 33.0818 71.3063 36.9671 68.0653 39.7557C63.3931 43.7781 51.9427 45.6426 46.8181 53.6875C44.0734 57.9978 45.6116 64.4879 46.2532 66.8104L77.7553 59.7828L109.257 52.7552C108.849 50.3807 107.483 43.8521 103.168 41.1184Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.83 50.397L34.0297 69.5358C31.5427 70.0896 29.6892 72.7054 30.2677 75.2938L127.332 53.6408C126.756 51.0551 122.94 49.7061 119.83 50.397Z",
    fill: "#CFDED1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2814 90.4483C80.6014 90.4483 80.0503 89.8972 80.0503 89.2172C80.0503 88.5372 80.6014 87.9861 81.2814 87.9861C83.0088 87.9861 84.4155 86.5794 84.4155 84.852C84.4155 83.1246 83.0088 81.718 81.2814 81.718C80.6014 81.718 80.0503 81.1669 80.0503 80.4869C80.0503 79.8069 80.6014 79.2557 81.2814 79.2557C84.3661 79.2557 86.8777 81.7674 86.8777 84.852C86.8777 87.9367 84.3688 90.4483 81.2814 90.4483Z",
    fill: "#B75E75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2814 96.3902C77.5606 96.3902 74.0975 94.7066 71.7833 91.77C71.361 91.2353 71.4543 90.4621 71.9889 90.0398C72.5236 89.6203 73.2968 89.7108 73.7191 90.2455C75.5644 92.5843 78.3201 93.9252 81.2841 93.9252C84.2481 93.9252 87.0038 92.5843 88.8491 90.2455C89.2714 89.7135 90.0446 89.6203 90.5793 90.0398C91.1139 90.4593 91.2044 91.2353 90.7849 91.77C88.4652 94.7066 85.0049 96.3902 81.2814 96.3902Z",
    fill: "#7C184B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.44 45.5438L144.22 42.8621C144.933 42.3631 145.317 41.6118 145.251 40.8386L143.071 20.137C142.978 19.0402 141.152 18.8346 140.713 19.8683L132.588 39.7692C132.284 40.4849 132.399 41.2773 132.901 41.9107L136.937 45.3162L138.44 45.5438Z",
    fill: "#CDDDD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2362 109.601C39.5601 112.156 37.1965 115.466 35.6419 119.751C34.9454 121.668 35.9352 123.788 37.8546 124.484C38.2714 124.635 38.6964 124.706 39.1159 124.706C40.6267 124.706 42.0443 123.774 42.5872 122.271C43.7141 119.167 45.447 116.755 47.4239 114.879C46.138 113.508 43.8951 111.156 42.2362 109.601Z",
    fill: "#CFDED1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.95 102.244C134.538 100.964 134.79 98.6385 133.512 97.0509C132.232 95.4606 129.91 95.211 128.319 96.4888C126.372 98.0572 124.522 99.2719 122.77 100.223L125.846 106.971C128.111 105.773 130.485 104.227 132.95 102.244Z",
    fill: "#CDDDD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.002 143.028L141.78 31.0581C141.876 30.3836 141.407 29.7612 140.732 29.668C140.337 29.6104 139.967 29.7694 139.704 30.0354C139.52 29.8517 139.293 29.7064 139.016 29.668C138.349 29.572 137.719 30.0409 137.626 30.7154L121.824 142.858C121.816 142.918 121.876 142.973 121.933 143.031H126.002V143.028Z",
    fill: "#CDDDD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.61 101.021C125.61 101.021 129.265 104.454 130.941 101.021C132.657 97.5034 128.317 96.4889 128.317 96.4889L125.61 101.021Z",
    fill: "#CDDDD0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_227_2296",
    x: 30.1613,
    y: 19.1938,
    width: 115.097,
    height: 129.321,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.48387
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_227_2296"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_227_2296",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPawnWhite);
export default __webpack_public_path__ + "static/media/pawn-white.f120d8decceccf12b8e1e9d2538a91e7.svg";
export { ForwardRef as ReactComponent };